import Wynyard81 from '../../../Media/BSD/Hiera/Wynyard 7.webp'
import Wynyard82 from '../../../Media/BSD/Hiera/Wynyard 7.webp'





const Wynyard8images =[
Wynyard81,Wynyard82
]

export default Wynyard8images;